import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import Api from '../../../Api';
import classes from './styles.module.css';
import Loader from '../../Utils/Loader';

function AntiFraudForm({ token, reference, onAdded }) {
    const intl = useIntl();
    const [kind, setKind] = useState('');
    const [value, setValue] = useState('');
    const [reasonMessage, setReasonMessage] = useState('');
    const [expiresAt, setExpiresAt] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    async function handleSubmit(e) {
        e.preventDefault();
        setError(null);

        if (!kind) {
            setError(intl.formatMessage({ id: 'AntiFraudForm.error.kindRequired' }));
            return;
        }

        if (!value) {
            setError(intl.formatMessage({ id: 'AntiFraudForm.error.valueRequired' }));
            return;
        }

        setLoading(true);

        try {
            const payload = {
                kind,
                value,
                reasonMessage: reasonMessage || intl.formatMessage({ id: 'AntiFraudForm.reason.default' }),
            };

            if (expiresAt) {
                payload.expiresAt = expiresAt;
            }

            await new Api({ token }).addAntiFraudRecord(payload);
            onAdded();
        } catch (err) {
            setError(
                (err && err.response && err.response.data && err.response.data.message) ||
                    intl.formatMessage({ id: 'AntiFraudForm.error.create' })
            );
        } finally {
            setLoading(false);
        }
    }

    return (
        <form className={classes.Form} onSubmit={handleSubmit}>
            {error && <div className={classes.Error}>{error}</div>}

            <div className={classes.Field}>
                <label className={classes.Label}>
                    <FormattedMessage id="AntiFraudForm.kind" />
                </label>
                <select className={classes.Select} value={kind} onChange={(e) => setKind(e.target.value)}>
                    <option value="">{intl.formatMessage({ id: 'AntiFraudForm.kind.placeholder' })}</option>
                    {(reference.kinds || []).map((k) => (
                        <option key={k.value} value={k.value}>
                            {k.label}
                        </option>
                    ))}
                </select>
            </div>

            <div className={classes.Field}>
                <label className={classes.Label}>
                    <FormattedMessage id="AntiFraudForm.value" />
                </label>
                <input
                    type="text"
                    className={classes.Input}
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    placeholder={
                        kind === 'card_pan'
                            ? intl.formatMessage({ id: 'AntiFraudForm.placeholder.cardPan', defaultMessage: '4111111111111111' })
                            : kind === 'phone' || kind === 'sbp_phone'
                              ? intl.formatMessage({ id: 'AntiFraudForm.placeholder.phone', defaultMessage: '79001234567' })
                              : kind === 'ip'
                                ? intl.formatMessage({ id: 'AntiFraudForm.placeholder.ip', defaultMessage: '192.168.1.1' })
                                : kind === 'inn'
                                  ? intl.formatMessage({ id: 'AntiFraudForm.placeholder.inn', defaultMessage: '1234567890' })
                                  : intl.formatMessage({ id: 'AntiFraudForm.value.placeholder' })
                    }
                />
                <div className={classes.Hint}>
                    {kind === 'card_pan' && intl.formatMessage({ id: 'AntiFraudForm.hint.card_pan' })}
                    {kind === 'phone' && intl.formatMessage({ id: 'AntiFraudForm.hint.phone' })}
                    {kind === 'sbp_phone' && intl.formatMessage({ id: 'AntiFraudForm.hint.sbp_phone' })}
                    {kind === 'ip' && intl.formatMessage({ id: 'AntiFraudForm.hint.ip' })}
                    {kind === 'inn' && intl.formatMessage({ id: 'AntiFraudForm.hint.inn' })}
                    {kind === 'name' && intl.formatMessage({ id: 'AntiFraudForm.hint.name' })}
                </div>
            </div>

            <div className={classes.Field}>
                <label className={classes.Label}>
                    <FormattedMessage id="AntiFraudForm.reason" />
                </label>
                <input
                    type="text"
                    className={classes.Input}
                    value={reasonMessage}
                    onChange={(e) => setReasonMessage(e.target.value)}
                    placeholder={intl.formatMessage({ id: 'AntiFraudForm.reason.default' })}
                />
            </div>

            <div className={classes.Field}>
                <label className={classes.Label}>
                    <FormattedMessage id="AntiFraudForm.expiresAt" />
                </label>
                <input
                    type="datetime-local"
                    className={classes.Input}
                    value={expiresAt}
                    onChange={(e) => setExpiresAt(e.target.value)}
                />
                <div className={classes.Hint}>
                    <FormattedMessage id="AntiFraudForm.expiresAt.hint" />
                </div>
            </div>

            <div className={classes.Actions}>
                <button type="submit" className={classes.Submit} disabled={loading}>
                    {loading ? (
                        <Loader isString={true} />
                    ) : (
                        <FormattedMessage id="AntiFraudForm.submit" />
                    )}
                </button>
            </div>
        </form>
    );
}

AntiFraudForm.defaultProps = {
    reference: { sources: [], kinds: [] },
    onAdded: () => {},
};

export default AntiFraudForm;



// WEBPACK FOOTER //
// ./src/Components/ComponentsOfAdministrator/AntiFraudForm/index.js